const initState = {
    data: null,
  };
  
  const adminCmsReducer = (state = initState, action) => {
    switch (action.type) {
      case "ADMIN_CMS":
        return {
          ...state,
          data: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default adminCmsReducer;